import {store} from "../../redux/Store";

/**
 * Доступ к оплате картой задаётся в БД (страница «Payment & Stripe») и приходит в
 * {@link PaymentConfigReducer} после GET /application-settings/client-context.
 */
export function isUserAllowedCardPayment(user: { email?: string; login?: string } | null | undefined): boolean {
    if (!user) {
        return false;
    }
    const p = store.getState().PaymentConfigReducer;
    if (!p?.loaded) {
        return false;
    }
    return p.cardPaymentAllowed;
}
